import React from "react";
import { Dropdown, Space } from "antd";
import { GlobalOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { setLanguage } from "redux-polyglot/dist/actions";
import { useDispatch, useSelector } from "react-redux";
import { SvgArrowDownIcon, SvgArrowRightIcon } from "../../components/svg";
import HeaderMobile from "./mobile";

const HeaderLayout = () => {
  const dispatch = useDispatch();
  const { isMobileView } = useSelector(({ settings }) => settings);
  const { phrases, locale } = useSelector(({ polyglot }) => polyglot);

  const handleLang = (lang) => {
    localStorage.setItem("lang", lang);
    const translate = require(`lang/${lang}.json`);
    dispatch(setLanguage(lang, translate));
  };

  const menuLang = (
    <div className="mpx-overflow mpx-overflow--lang">
      <div>
        <Link onClick={() => handleLang("id")} to="#">
          Bahasa Indonesia
        </Link>
      </div>
      <div>
        <Link onClick={() => handleLang("en")} to="#">
          English
        </Link>
      </div>
    </div>
  );

  if (phrases) {
    const {
      components: { header, nav },
    } = phrases;

    const menuAboutChild = (
      <ul>
        <li>
          <Link to="/struktur-perusahaan/dewan-komisaris">
            {nav.aboutUs.boardOfCommissioners}
          </Link>
        </li>
        <li>
          <Link to="/struktur-perusahaan/direksi">
            {nav.aboutUs.boardOfDirectors}
          </Link>
        </li>
        <li>
          <Link to="/struktur-perusahaan/struktur-organisasi">
            {nav.aboutUs.organizationalStructure}
          </Link>
        </li>
      </ul>
    );

    const menuAbout = (
      <ul>
        <li>
          <Link to="/profil-perusahaan">{nav.aboutUs.companyProfile}</Link>
        </li>
        <li id="aboutStuctureNav">
          <Dropdown
            overlay={menuAboutChild}
            getPopupContainer={() =>
              document.getElementById("aboutStuctureNav")
            }
            overlayClassName="mpx-overflow mpx-overflow--nav mpx-overflow--child"
          >
            <Link to="#">
              <Space style={{ justifyContent: "space-between", width: "100%" }}>
                {nav.aboutUs.companyStructure}
                <SvgArrowRightIcon />
              </Space>
            </Link>
          </Dropdown>
        </li>
        <li>
          <Link to="/karir">{nav.aboutUs.career}</Link>
        </li>
        <li>
          <Link to="/hubungi-kami">{nav.aboutUs.contactUs}</Link>
        </li>
      </ul>
    );

    const menuKelola = (
      <ul>
        <li>
          <Link to="/tata-kelola/rups#">{nav.governance.rups}</Link>
        </li>
        {/* <li>
          <Link to="#">{nav.governance.publicExposure}</Link>
        </li> */}
        <li>
          <Link to="/tata-kelola/piagam">{nav.aboutUs.charter}</Link>
        </li>
        {/* <li>
          <Link to="#">{nav.governance.complaint}</Link>
        </li> */}
        {/* <li>
          <Link to="#">{nav.governance.publicBudget}</Link>
        </li> */}
        {/* <li>
          <Link to="#">{nav.governance.sustainabilityReport}</Link>
        </li> */}
      </ul>
    );

    const menuHubInvestor = (
      <ul>
        <li>
          <Link to="/hubungan-investor/prospektus">
            {nav.investorRelations.Prospectus}
          </Link>
        </li>
        {/* <li>
          <Link to="#">{nav.investorRelations.information}</Link>
        </li> */}
        {/* <li>
          <Link to="#">{nav.investorRelations.summary}</Link>
        </li> */}
        <li>
          <Link to="/hubungan-investor/laporan-keuangan">
            {nav.investorRelations.financialStatements}
          </Link>
        </li>
        <li>
          <Link to="/hubungan-investor/laporan-tahunan">
            {nav.investorRelations.annualReport}</Link>
        </li>
        <li>
          <Link to="/hubungan-investor/infromasi-pemegang-saham">{nav.investorRelations.shareholderInformation}</Link>
        </li>
        <li>
          <Link to="/hubungan-investor/infromasi-saham">{nav.investorRelations.stockInformation}</Link>
        </li>
        <li>
          <Link to="/hubungan-investor/dividen">{nav.investorRelations.dividend}</Link>
        </li>
        <li>
          <Link to="/hubungan-investor/investor-news">{nav.investorRelations.investorNews}</Link>
        </li>

      </ul>
    );

    return (
      <div className="mpx-header">
        {isMobileView && <HeaderMobile />}
        {!isMobileView && (
          <>
            <div className="mpx-header--top">
              <div className="mpx-container" style={{ textAlign: "right" }}>
                <Link to="/">{header.home}</Link>
                <Link to="/artikel">{header.newsAndArticle}</Link>
                <Link to="/karir">{header.career}</Link>
                <Link to="#">
                  <Dropdown overlay={menuLang}>
                    <Space>
                      <GlobalOutlined style={{ marginRight: "5px" }} />
                      <span>{locale === "en" ? "English" : "Bahasa"}</span>
                      <SvgArrowDownIcon />
                    </Space>
                  </Dropdown>
                </Link>
              </div>
            </div>
            <div className="mpx-header--bottom">
              <div className="mpx-container">
                <div className="wrap">
                  <div className="logo">
                    <Link to="/">
                      {/* <img src='/images/logo/logo-mpxgo-main.png' alt='MPX LOGO' /> */}
                      <img
                        src="/images/logo/LOGO MLI WEBSITE.png"
                        alt="MPX LOGO"
                        style={{ maxWidth: "50%" }}
                      />
                    </Link>
                  </div>
                  <div className="mpx-nav">
                    <Dropdown
                      overlay={menuAbout}
                      getPopupContainer={() =>
                        document.getElementById("navAboutUs")
                      }
                      overlayClassName="mpx-overflow mpx-overflow--nav"
                    >
                      <div className="nav-item" id="navAboutUs">
                        <Link to="#">
                          <Space>
                            <span>{nav.aboutUs.aboutUs}</span>
                            <SvgArrowDownIcon />
                          </Space>
                        </Link>
                      </div>
                    </Dropdown>
                    <div className="nav-item">
                      <Link to="/usaha-kami">{nav.ourBusiness}</Link>
                    </div>
                    <Dropdown
                      overlay={menuKelola}
                      getPopupContainer={() =>
                        document.getElementById("navKelola")
                      }
                      overlayClassName="mpx-overflow mpx-overflow--nav"
                    >
                      <div className="nav-item" id="navKelola">
                        <Link to="#">
                          <Space>
                            <span>{nav.governance.governance}</span>
                            <SvgArrowDownIcon />
                          </Space>
                        </Link>
                      </div>
                    </Dropdown>
                    <Dropdown
                      overlay={menuHubInvestor}
                      getPopupContainer={() =>
                        document.getElementById("navHubInvestor")
                      }
                      overlayClassName="mpx-overflow mpx-overflow--nav"
                    >
                      <div className="nav-item" id="navHubInvestor">
                        <Link to="#">
                          <Space>
                            <span>
                              {nav.investorRelations.investorRelations}
                            </span>
                            <SvgArrowDownIcon />
                          </Space>
                        </Link>
                      </div>
                    </Dropdown>
                    <div className="nav-item">
                      <Link to="/kepedulian-sosial">
                        {nav.socialResponsibility}
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    );
  } else {
    return false;
  }
};

export default HeaderLayout;
